if (!customElements.get('media-gallery')) {
    class MediaGallery extends HTMLElement {
        constructor () {
            super();

            this.initializeSwiper();
        }

        initializeSwiper () {
            const thumbnailSliderEl = this.querySelector('.thumbnail-slider');
            const mediaGallerySliderEl = this.querySelector('.media-gallery-slider');

            if (!thumbnailSliderEl || !mediaGallerySliderEl) {
                return;
            }

            try {
                const thumbSlider = new Swiper(thumbnailSliderEl, {
                    spaceBetween: 10,
                    slidesPerView: 5,
                    slidesPerGroup: 1,
                    observer: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                });

                const swiper = new Swiper(mediaGallerySliderEl, {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                    observer: true,
                    watchSlidesProgress: true,
                    centerInsufficientSlides: true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                    },
                    thumbs: {
                        swiper: thumbSlider,
                    },
                });

                swiper.on('observerUpdate', () => {
                    swiper.update();
                    thumbSlider.update();

                    swiper.slideTo(0);
                    thumbSlider.slideTo(0);
                });
            } catch (error) {
                console.warn('MediaGallery: Swiper initialization failed', error);
            }
        }
    }

    customElements.define('media-gallery', MediaGallery);
}
